import { Component, OnInit } from '@angular/core';
import { WizardPageComponent } from 'src/app/core/wizard/wizard-page-component';
import { LowPopulationAlertWizard } from '../low-population-alert-wizard';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'mtn-low-population-alert',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './low-population-alert.component.html',
  styleUrl: './low-population-alert.component.scss'
})
export class LowPopulationAlertComponent extends WizardPageComponent<LowPopulationAlertWizard> implements OnInit {
  key = 'point-click';

  constructor(){
    super();
  }

  ngOnInit(): void {
    this.title =`Population Too Low to Project Sales`;
    this.closeButtonText = 'Close';
  }
}
